(() => {
  angular
    .module('gm.common.directives')
    .directive('gmBoxInputAutocomplete', gmBoxInputAutocomplete);

  function gmBoxInputAutocomplete() {
    'ngInject';

    return {
      restrict: 'E',
      require: 'ngModel',
      replace: true,
      scope: {
        options: '=',
        activeItem: '=?',
        label: '@',
        tooltip: '@',
        tooltipType: '@',
        metaLeft: '@',
        placeholder: '@',
      },
      templateUrl:
        'modules/common/directives/forms/box-input-autocomplete/box-input-autocomplete.html',
      link,
    };

    function link(scope, _element, _attrs, ctrl) {
      scope.input = '';
      scope.onInputChange = onInputChange;
      scope.onFocus = onFocus;
      scope.selectItem = selectItem;

      function onInputChange() {
        onFocus();
        ctrl.$setViewValue({ id: null, name: scope.input });
      }

      function onFocus() {
        const input = scope.input;
        if (input || (scope.options && scope.options.length < 200)) {
          const ri = new RegExp(scope.input, 'i');
          const filteredOptions = scope.options.filter(({ name }) => ri.test(name));
          scope.filteredOptions = filteredOptions.slice(0, 200);
          if (scope.filteredOptions.length) {
            scope.view.isOpen = true;
          }
        }
      }

      function selectItem({ id, name }) {
        scope.input = name;
        ctrl.$setViewValue({ id, name });
      }

      ctrl.$formatters.push((val) => {
        scope.input = val.name;
        return val;
      });
    }
  }
})();
